// extracted by mini-css-extract-plugin
export var title = "Widget-module--title--mQDY5";
export var titleText = "Widget-module--titleText--tl10t";
export var widget = "Widget-module--widget--SOVf9";